module.exports = __webpack_public_path__ + "static/media/1POLICY39.25be6a9d.jpg";